export default __webpack_public_path__ + "static/media/delfi-de-la-rua-vfzfavUZmfc-unsplash.bad27fd9.jpg";